"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  ADD_BUTTON: {
    ACTIVE_COLOR: 'secondary',
    DISABLED_COLOR: 'greyMedium',
    TYPE: 'default'
  },
  ROOM_SUBMIT_BUTTON: {
    BACKGROUND_COLOR: 'primary',
    BUTTON_TYPE: 'button',
    COLOR: 'default',
    SIZE: 'normal',
    TYPE: 'normal'
  },
  ICON: {
    COLOR: 'greyMediumDark',
    SIZE: 'titleMedium',
    TYPE: 'CloseIcon'
  },
  MOBILE_HEADER_TITLE: {
    COLOR: 'neutral'
  }
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;